import { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import CountUp from "react-countup";
import Header from "../../component/Header";
import IconArrowUp from "../../component/SvgIcons/IconArrowUp";
import AssistVia from "../../component/AssistVia";
import RecentCustomers from "../../component/RecentCustomers";
import SalesReportChart from "../../component/SalesReportChart";
import { useAuth } from "../../context/AuthContext";
import api from "../../services/axios";
import CustomDropdown from "../../component/CustomDropdown";
import "./style.css";
import PieChart from "../../component/piechart";
import Applicationticket from "../../component/piechart/Applicationticket";
import CallDetails from "../../component/piechart/CallDetailsstatus";
import CallDetailspickuphours from "../../component/piechart/CallDetailspickuphours";
import CurrentCallBox from "../../component/CallModal/CurrentCallBox";
import CallLog from "../../component/CallLog";

export default function Dashboard() {
  const { authUserInfo } = useAuth();
  let [authUser, setAuthUser] = useState()
  const [summary, setSummary] = useState(null);
  const [previousSummary, setPreviousSummary] = useState(null);
  const [selectedDays, setSelectedDays] = useState("today");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isEscalate, setIsEscalate] = useState(false);
  const dropdownRef = useRef(null);
  const days = [
    { value: "selected", label: "selected" },
    { value: "today", label: "Today" },
    { value: "yesterday", label: "Yesterday" },
    { value: 7, label: "7 Days" },
    { value: 30, label: "30 Days" },
    { value: 180, label: "6 Months" },
    { value: 365, label: "12 Months" },
    { value: "All", label: "All" },
  ];

  useEffect(() => {
    const fetchAuth = async () => {
      let authUserLocal = await authUserInfo();
      setAuthUser(authUserLocal);
    }

    fetchAuth();
  }, [])


  useEffect(() => {
    let escalationOnly =
      authUser?.Agents_Company === "Gulf Konnect" ||
      authUser?.Agents_Company === "Field Assist";
    setIsEscalate(escalationOnly);
  }, [authUser])

  const indianNumberFormatter = (value) =>
    new Intl.NumberFormat("en-IN").format(value);

  const getPreviousFilter = (filter) => {
    if (filter === "today") return "yesterday";
    if (filter === "yesterday") return 2;
    if (filter === "All") return "All";
    if (typeof filter === "number") return filter * 2;
    return "yesterday";
  };
  const calculateGrowth = (current, previous) => {
    if (previous === 0) return null;
    return Math.round(((current - previous) / previous) * 100);
  };
  const handleChange = (value) => {
    setSelectedDays(value);
  };

  useEffect(() => {
    const loadSummary = async () => {
      try {
        if (isEscalate) {

          const res = await api.post("/Escalated_Dashboard_Summary", {
            // isAdmin: authUser.isAdmin,
            // Code: authUser?.Code,
            // Agents_Company: authUser?.Agents_Company,
            dateFilter: selectedDays,
          });
          setSummary(res.data);
        } else {
          const [currentRes, prevRes] = await Promise.all([
            api.post("/Dashboard_Summary", {
              // isAdmin: authUser.isAdmin,
              // Code: authUser?.Code,
              dateFilter: selectedDays,
            }),
            api.post("/Dashboard_Summary", {
              // isAdmin: authUser.isAdmin,
              // Code: authUser?.Code,
              dateFilter: getPreviousFilter(selectedDays),
            }),
          ]);
          setSummary(currentRes.data);
          setPreviousSummary(prevRes.data);
        }
      } catch (error) {
        console.error("Error loading dashboard summary:", error);
      }
    };

    loadSummary();
  }, [selectedDays, isEscalate]);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  const isGlobal =
    authUser?.Agents_Company === "Global Assist" ||
    authUser?.Agents_Company === "Gulf Oil" ||
    authUser?.Agents_Company === "Global Gulf Support" ||
    authUser?.Agents_Company === "Global Software";

  const isEscalationOnly =
    authUser?.Agents_Company === "Gulf Konnect" ||
    authUser?.Agents_Company === "Field Assist";

  return (
    <div className="dashboard">
      <Header searchbar title />
      <div className="center-content">
        <div className="container">
          <AnimatePresence mode="wait">
            <motion.form
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.3 }}
            >

              <div className="pagegap d-flex flex-column">

                <div className="dashboardpage">
                  <h1 className="dashboard-title">
                    <span>Hey {authUser?.Agent_Name}</span> – here’s what’s
                    happening with Global Assist Today
                  </h1>
                  <div className="selectinput">
                    <CustomDropdown
                      options={days}
                      placeholder="Select Days"
                      onChange={handleChange}
                      name="days"
                      className="selectinput"
                      value={selectedDays}
                    />
                  </div>
                </div>


                {/* {isGlobal && (
                <div className="callboxes-main d-flex gap-3">
                 <CurrentCallBox
                  name="Mark Joe"
                  time="10:00"
                  role="Retailer"
                  address="New Delhi - 110001"
                  status="incoming" // or "ended" or "missed"
                />

                <CurrentCallBox
                  name="Edward Doe"
                  time="15:00"
                  role="Employee"
                  address="Mumbai - 400001"
                  status="outgoing" // or "ended" or "missed"
                />

                <CurrentCallBox
                  name="Mark Rose"
                  time="01:00"
                  role="Employee"
                  address="Bangalore - 560001"
                  status="ended" // or "ended" or "missed"
                />
                <CurrentCallBox
                  name="Miss Rose"
                  time="01:00"
                  role="Employee"
                  address="Bangalore - 560001"
                  status="minsed" // or "ended" or "missed"
                />
                </div> 
    )} */}


                <div className="salesboxes-main d-flex flex-column flex-md-row justify-content-between">
                  {isEscalate ? (
                    <>
                      <TicketBox
                        label="In Progress Escalated Tickets"
                        filterName="1"
                        day={selectedDays}
                        growth={calculateGrowth(
                          summary?.inprogressEscalatedTickets ?? 0,
                          previousSummary?.inprogressEscalatedTickets ?? 0
                        )}
                        count={summary?.inprogressEscalatedTickets ?? 0}
                      />

                      <TicketBox
                        label="Closed Escalated Tickets"
                        filterName="4"
                        day={selectedDays}
                        growth={calculateGrowth(
                          summary?.closedEscalatedTickets ?? 0,
                          previousSummary?.closedEscalatedTickets ?? 0
                        )}
                        count={summary?.closedEscalatedTickets ?? 0}
                      />

                      <TicketBox
                        label="Total Escalated Tickets"
                        filterName="3"
                        day={selectedDays}
                        growth={calculateGrowth(
                          summary?.totalEscalatedTickets ?? 0,
                          previousSummary?.totalEscalatedTickets ?? 0
                        )}
                        count={summary?.totalEscalatedTickets ?? 0}
                      />

                    </>

                  ) : (

                    <>
                      <TicketBox
                        label="Reopen Tickets"
                        filterName="2"
                        day={selectedDays}
                        count={summary?.todaysOpenTickets ?? 0}
                        growth={calculateGrowth(
                          summary?.todaysOpenTickets ?? 0,
                          previousSummary?.todaysOpenTickets ?? 0
                        )}
                      />

                      <TicketBox
                        label="In Progress Tickets"
                        filterName="1"
                        day={selectedDays}
                        count={summary?.inprogressTickets ?? 0}
                        growth={calculateGrowth(
                          summary?.inprogressTickets ?? 0,
                          previousSummary?.inprogressTickets ?? 0
                        )}
                      />

                      <TicketBox
                        label="Escalated Tickets"
                        filterName="3"
                        day={selectedDays}
                        count={summary?.escalatedTickets ?? 0}
                        formatter={indianNumberFormatter}
                        prefix="₹"
                        growth={calculateGrowth(
                          summary?.escalatedTickets ?? 0,
                          previousSummary?.escalatedTickets ?? 0
                        )}
                      />

                      <TicketBox
                        label="Closed Tickets"
                        filterName="4"
                        day={selectedDays}
                        count={summary?.closedTickets ?? 0}
                        growth={calculateGrowth(
                          summary?.closedTickets ?? 0,
                          previousSummary?.closedTickets ?? 0
                        )}
                        selectedDays={selectedDays}
                      />

                      <TicketBox
                        label="Total Tickets"
                        filterName="5"
                        day={selectedDays}
                        count={summary?.totalTickets ?? 0}
                        growth={calculateGrowth(
                          summary?.totalTickets ?? 0,
                          previousSummary?.totalTickets ?? 0
                        )}
                      />
                    </>
                  )}
                </div>

                <SalesReportChart />


                <div className="dashboardbottompart pagegap d-flex justify-content-between flex-column flex-xxl-row">
                  {isGlobal && (
                    <>
                      <CallLog />
                    </>
                  )}
                </div>


                <div className="dashboardbottompart pagegap d-flex  flex-column flex-xxl-row">
                  {isGlobal && (
                    <>
                      <Applicationticket />
                      <CallDetailspickuphours />
                      <CallDetails />

                    </>
                  )}

                </div>



                {/* <div className="dashboardbottompart pagegap d-flex justify-content-between flex-column flex-xxl-row">
                  {isGlobal && (
                    <>
                      <AssistVia />
                      <PieChart />
                    </>
                  )}

                  <TicketBox
                    label="Total Tickets"
                    count={summary?.totalTickets ?? 0}
                    growth={calculateGrowth(
                      summary?.totalTickets ?? 0,
                      previousSummary?.totalTickets ?? 0
                    )}
                  />
                </div> */}

                {/* <SalesReportChart /> */}

                <div className="dashboardbottompart pagegap d-flex justify-content-between flex-column flex-xxl-row">
                  {isGlobal && (
                    <>
                      <AssistVia />
                      <PieChart />
                    </>
                  )}
                  <RecentCustomers />
                </div>
              </div>
            </motion.form>
          </AnimatePresence>
        </div>
      </div>
    </div >
  );
}

function TicketBox({
  label,
  count = 0,
  formatter,
  prefix = "",
  growth = 0,
  filterName = "2",
  day = "",
}) {
  const isPositive = growth >= 0;
  const toLink =
    label.includes('Escalated')
      ? `/escalations-report?day=${day}&filterName=${filterName}`
      : `/reports?day=${day}&filterName=${filterName}`;



  return (
    <Link to={toLink} className={`salesboxes ${isPositive ? "up" : "down"}`}>
      <h2>{label}</h2>
      <div className="countbox d-flex justify-content-between align-items-end">
        <CountUp
          end={count}
          duration={2}
          separator=","
          formattingFn={formatter}
          prefix={prefix}
        />
        <small>
          {isPositive ? "+" : "-"} {Math.abs(growth)}% <IconArrowUp />
        </small>
      </div>
    </Link>
  );
}
